
export const dynamicCancellationValue = (data) => {
    if (data === 1) {
        return { name: "flexible", content: "flexibleContentLabel" };
    } else if (data === 2) {
        return { name: "moderate", content: "moderateContentLabel" };
    } else if (data === 3) {
        return { name: "strict", content: "strictContentLabel" };
    }
};